<div class="op-painel" *ngIf="state">
  <div class="op-painel--backdrop"
       *ngIf="openMenu !== null || openRole !== null"
       (click)="closeMenus()"></div>

  <div class="op-painel--search">
    <span class="op-painel--search-icon"><op-icon icon-classes="icon-search"></op-icon></span>
    <input type="text"
           class="op-painel--search-input"
           [placeholder]="text.searchPlaceholder"
           [(ngModel)]="query"
           (ngModelChange)="onQuery()"
           (focus)="onQuery()"
           autocomplete="off">

    <div class="op-painel--results" *ngIf="results">
      <button type="button"
              class="op-painel--result"
              *ngFor="let d of results.list"
              (mousedown)="pick(d)">
        <op-principal [principal]="{ name: d.name, href: principalHref(d) }"
                      size="default"
                      [hideName]="true"
                      [link]="false"></op-principal>
        <span class="op-painel--meta">
          <span class="op-painel--name">{{ d.name }}</span>
          <span class="op-painel--sub">{{ d.sub || d.email }}</span>
        </span>
      </button>

      <button type="button"
              class="op-painel--result -invite"
              *ngIf="results.invite"
              (mousedown)="pickInvite(results.invite)">
        <span class="op-painel--invite-avatar"><op-icon icon-classes="icon-mail1"></op-icon></span>
        <span class="op-painel--meta">
          <span class="op-painel--name">{{ text.invitePrefix }} {{ results.invite }}</span>
          <span class="op-painel--sub">{{ text.inviteHint }}</span>
        </span>
        <span class="op-painel--invite-badge">{{ text.inviteBadge }}</span>
      </button>

      <div class="op-painel--no-results" *ngIf="!results.list.length && !results.invite">
        {{ text.noResults }}
      </div>
    </div>
  </div>

  <p class="op-painel--hint">{{ text.hint }}</p>

  <div class="op-painel--group" *ngFor="let g of sections">
    <div class="op-painel--group-header">
      {{ g.title }}<span class="op-painel--count">{{ g.items.length }}</span>
    </div>

    <div class="op-painel--empty" *ngIf="!g.items.length && g.empty">{{ g.empty }}</div>

    <div class="op-painel--row"
         *ngFor="let m of g.items"
         [class.-open]="openMenu === m.id || openRole === m.id">
      <op-principal [principal]="{ name: m.name, href: principalHref(m) }"
                    size="default"
                    [hideName]="true"
                    [link]="false"></op-principal>

      <span class="op-painel--meta">
        <span class="op-painel--name">
          {{ m.name }}<span class="op-painel--you" *ngIf="m.you"> {{ text.you }}</span>
        </span>
        <span class="op-painel--sub">{{ m.sub || m.email }}</span>
      </span>

      <button type="button"
              class="op-painel--role"
              *ngIf="canManage && !m.pending"
              (click)="$event.stopPropagation(); toggleRole(m, $event)">
        {{ m.role === 'manager' ? text.gestor : text.membro }}
        <op-icon icon-classes="icon-arrow-down1"></op-icon>
      </button>
      <span class="op-painel--role-static" *ngIf="!canManage && !m.pending">
        {{ m.role === 'manager' ? text.gestor : text.membro }}
      </span>

      <button type="button"
              class="op-painel--kebab"
              [title]="text.remove"
              (click)="$event.stopPropagation(); toggleMenu(m, $event)">
        <op-icon icon-classes="icon-show-more-horizontal"></op-icon>
      </button>

      <div class="op-painel--menu -roles" *ngIf="openRole === m.id" [ngStyle]="menuStyle" (click)="$event.stopPropagation()">
        <button type="button" class="op-painel--menu-item -role" (click)="setRole(m, 'gestor')">
          <span class="op-painel--check"><op-icon icon-classes="icon-checkmark" *ngIf="m.role === 'manager'"></op-icon></span>
          <span><span class="op-painel--menu-label">{{ text.gestor }}</span><span class="op-painel--sub">{{ text.gestorDesc }}</span></span>
        </button>
        <button type="button" class="op-painel--menu-item -role" (click)="setRole(m, 'membro')">
          <span class="op-painel--check"><op-icon icon-classes="icon-checkmark" *ngIf="m.role === 'member'"></op-icon></span>
          <span><span class="op-painel--menu-label">{{ text.membro }}</span><span class="op-painel--sub">{{ text.membroDesc }}</span></span>
        </button>
      </div>

      <div class="op-painel--menu -actions" *ngIf="openMenu === m.id" [ngStyle]="menuStyle" (click)="$event.stopPropagation()">
        <button type="button" class="op-painel--menu-item" *ngIf="m.pending" (click)="resend(m)">
          <op-icon icon-classes="icon-mail1"></op-icon> {{ text.resend }}
        </button>
        <button type="button" class="op-painel--menu-item" *ngIf="canManage && !m.pending" (click)="setRole(m, m.role === 'manager' ? 'membro' : 'gestor')">
          <op-icon icon-classes="icon-group"></op-icon> {{ m.role === 'manager' ? text.makeMember : text.makeManager }}
        </button>
        <button type="button" class="op-painel--menu-item -danger" (click)="remove(m)">
          <op-icon icon-classes="icon-delete"></op-icon> {{ m.pending ? text.cancelInvite : (m.you ? text.leave : text.remove) }}
        </button>
      </div>
    </div>
  </div>
</div>
